/**
 * Chat file-attachment constraints. These mirror the backend `POST /file`
 * limits (see apps/server/src/file/constants.ts + config defaults) so the
 * client rejects unsupported picks before an upload round-trip. Keep these in
 * sync with the server allowlist/size/count.
 */

/** MIME types the backend accepts for chat attachments. */
export const CHAT_ALLOWED_FILE_MIME_TYPES = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
  'application/pdf',
] as const;

export type ChatAllowedFileMimeType = (typeof CHAT_ALLOWED_FILE_MIME_TYPES)[number];

/** Max attachments per message (backend caps `file_ids` at 5). */
export const CHAT_MAX_FILES = 5;

/** Max bytes per file (backend default is 10 MiB). */
export const CHAT_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;

/**
 * `accept` string for the file picker / drag-drop. Uses exact MIME types
 * (not `image/*`) so the OS dialog and our matcher filter to exactly the
 * supported set.
 */
export const CHAT_FILE_ACCEPT = CHAT_ALLOWED_FILE_MIME_TYPES.join(',');
